import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

interface CircleLoadingProps {
  className?: string;
}

const CircleLoading: FunctionComponent<CircleLoadingProps> = ({
  className,
}) => {
  return (
    <svg
      className={className || ''}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 27 27"
    >
      <path
        className="path-bg"
        d="m25.5,13.5c0,6.63-5.37,12-12,12S1.5,20.13,1.5,13.5,6.87,1.5,13.5,1.5s12,5.37,12,12"
      />
      <path
        className="path"
        d="m25.5,13.5c0,6.63-5.37,12-12,12S1.5,20.13,1.5,13.5,6.87,1.5,13.5,1.5s12,5.37,12,12"
      />
    </svg>
  );
};

export default styled(CircleLoading)`
  width: 24px;
  height: 24px;
  position: relative;
  animation: rotate 2s linear infinite;
  transform-origin: center center;

  path {
    fill: transparent;
    stroke-width: 2;
    stroke-linecap: round;
  }

  .path {
    stroke: ${({ theme }) => theme.colors.primary};
    stroke-dasharray: 150, 200;
    stroke-dashoffset: -10;
    animation: dash 1.5s ease-in-out infinite;
  }

  .path-bg {
    stroke: ${({ theme }) => theme.colors.tertiary};
    position: absolute;
    inset: 0;
    z-index: 0;
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -70;
    }
  }

  @keyframes rotate {
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`;
